import * as React from 'react';
import { Box, Button } from '@material-ui/core';

import FormRenderer from './FormRenderer';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 800,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  fontFamily: 'Rubik',
};

const CustomForm = ({
  title,
  buttonText,
  formFor = 'Entity',
  formTemplate,
  formData,
  setFormData,
  mode,
  handleSave,
  width,
}) => {
  return (
    <Box
      sx={style}
      style={{
        maxHeight: '80vh',
        width: width || '75vw',
        overflowY: 'auto',
      }}>
      <Box sx={{ fontSize: 18, fontWeight: 'bold' }}>
        {title
          ? title
          : mode == 'CREATE'
          ? `Add a ${formFor}`
          : `Edit the ${formFor}`}
      </Box>
      <Box alignItems="center" mt={2}>
        <FormRenderer
          formTemplate={formTemplate}
          formData={formData}
          setFormData={setFormData}
        />
      </Box>

      <Button variant="contained" color="primary" onClick={handleSave}>
        {buttonText
          ? buttonText
          : mode == 'CREATE'
          ? `Create ${formFor}`
          : `Save ${formFor}`}
      </Button>
    </Box>
  );
};

export default CustomForm;
